// React Native entry. Kept separate from the core so the core stays free of
// the Sentry SDK and tests in Node.
export { sentryReporter, type SentryReporterOptions } from "./sentry-reporter";
/**
 * Wraps the native root layout so Sentry records touches as breadcrumbs and
 * measures app start. Harmless when Sentry is not started (development, E2E).
 */
export { wrap as wrapRootComponent } from "@sentry/react-native";
